import "./styles/ShowPage.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Loader from "./components/Loader";
import BodyShow from "./components/BodyShow";
import { useEffect, useState } from "react";
import { client } from "./api/Client";
export default function Show(props) {
  let [load, setLoad] = useState(false);
  let [Img, setImg] = useState();
  useEffect(() => {
    setLoad(true);
    setTimeout(() => {
      setLoad(false);
    }, 2000);
    client.get("/GetShow")
    .then(res => {
        setImg(res.data.Show[0].ShowURL)
    })
    .catch(error => {
        alert(error)
    })
  }, []);
  return (
    <>
      {load ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          <Header />
            <BodyShow Url={ Img } />
          <Footer />
        </>
      )}
    </>
  );
}
